import { createSlice } from "@reduxjs/toolkit";
import { cardsCount, chartData, clientChartData, clientOverview, getAddType, getAllClients, getChequeList, getChequeType, getMemberList, getProvider, gettingDetail, manuallyChequeDetail, memberTypeData, quickStats, searchClientData, searchProvider, searchType } from "../Actions/DashOptions";

const initialState = {
    isLoading: false,
    listdata: [],
    getTypeData: [],
    memberList: [],
    detailOfMember: {},
    providerSearched: [],
    searchTypeData: [],
    memberSearchedData: [],
    allClients: [],
    clientSearchedData: [],
    getChequeList: [],
    getChequeTypeData: [],
    getDataForManually: [],
    getCardsCountData: [],
    getChartDataDashboard: [],
    quickStatsData: [],
    clientOverviewData: [],
    clientOverviewChart: [],
};

const DashOptionsSlice = createSlice({
    name: "AuthorizationsSlice",
    initialState,

    extraReducers: (bulider) => {
        bulider.addCase(getProvider.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(getProvider.fulfilled, (state, action) => {
            state.isLoading = false;
            state.listdata = action?.payload; // take array list for getting data 
        });
        bulider.addCase(getProvider.rejected, (state, action) => {
            state.isLoading = false;
        });
        // getting provider search data
        bulider.addCase(searchProvider.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(searchProvider.fulfilled, (state, action) => {
            state.isLoading = false;
            state.providerSearched = action?.payload; // take array list for getting data 
        });
        bulider.addCase(searchProvider.rejected, (state, action) => {
            state.isLoading = false;
        });

        // add type slice for getting list
        bulider.addCase(getAddType.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(getAddType.fulfilled, (state, action) => {
            state.isLoading = false;
            state.getTypeData = action?.payload; // take array list for getting data 
        });
        bulider.addCase(getAddType.rejected, (state, action) => {
            state.isLoading = false;
        });

        // getting type search data 

        bulider.addCase(searchType.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(searchType.fulfilled, (state, action) => {
            state.isLoading = false;
            state.searchTypeData = action?.payload; // take array list for getting data 
        });
        bulider.addCase(searchType.rejected, (state, action) => {
            state.isLoading = false;
        });


        // add getaddtype for getting member list
        bulider.addCase(getMemberList.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(getMemberList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.memberList = action?.payload; // take array list for getting data 
        });
        bulider.addCase(getMemberList.rejected, (state, action) => {
            state.isLoading = false;
        });


        // getting detail of indivial member
        bulider.addCase(gettingDetail.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(gettingDetail.fulfilled, (state, action) => {
            state.isLoading = false;
            state.detailOfMember = action?.payload; // take array list for getting data 
        });
        bulider.addCase(gettingDetail.rejected, (state, action) => {
            state.isLoading = false;
        });

        // getting member search data
        bulider.addCase(memberTypeData.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(memberTypeData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.memberSearchedData = action?.payload; // take array list for getting data 
        });
        bulider.addCase(memberTypeData.rejected, (state, action) => {
            state.isLoading = false;
        });

        //  get all clients
        bulider.addCase(getAllClients.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(getAllClients.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allClients = action?.payload; // take array list for getting data 
        });
        bulider.addCase(getAllClients.rejected, (state, action) => {
            state.isLoading = false;
        });

        // getting client search data 

        bulider.addCase(searchClientData.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(searchClientData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.clientSearchedData = action?.payload; // take array list for getting data 
        });
        bulider.addCase(searchClientData.rejected, (state, action) => {
            state.isLoading = false;
        });

        // getting cheque list data 

        bulider.addCase(getChequeList.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(getChequeList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.getChequeList = action?.payload; // take array list for getting data 
        });
        bulider.addCase(getChequeList.rejected, (state, action) => {
            state.isLoading = false;
        });

        // getting cheque type list data 

        bulider.addCase(getChequeType.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(getChequeType.fulfilled, (state, action) => {
            state.isLoading = false;
            state.getChequeTypeData = action?.payload; // take array list for getting data 
        });
        bulider.addCase(getChequeType.rejected, (state, action) => {
            state.isLoading = false;
        });


        // getting cheque data for enter manually detail after process
        bulider.addCase(manuallyChequeDetail.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(manuallyChequeDetail.fulfilled, (state, action) => {
            state.isLoading = false;
            state.getDataForManually = action?.payload; // take array list for getting data 
        });
        bulider.addCase(manuallyChequeDetail.rejected, (state, action) => {
            state.isLoading = false;
        });

        // get cards count data for dashboard
        bulider.addCase(cardsCount.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(cardsCount.fulfilled, (state, action) => {
            state.isLoading = false;
            state.getCardsCountData = action?.payload; // take array list for getting data 
        });
        bulider.addCase(cardsCount.rejected, (state, action) => {
            state.isLoading = false;
        });

        // get chart data for dashboard
        bulider.addCase(chartData.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(chartData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.getChartDataDashboard = action?.payload; // take array list for getting data 
        });
        bulider.addCase(chartData.rejected, (state, action) => {
            state.isLoading = false;
        });

        // get quick stats data for dashboard yearly base
        bulider.addCase(quickStats.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(quickStats.fulfilled, (state, action) => {
            state.isLoading = false;
            state.quickStatsData = action?.payload; // take array list for getting data 
        });
        bulider.addCase(quickStats.rejected, (state, action) => {
            state.isLoading = false;
        });

        // get quick stats data for dashboard yearly base
        bulider.addCase(clientOverview.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(clientOverview.fulfilled, (state, action) => {
            state.isLoading = false;
            state.clientOverviewData = action?.payload; // take array list for getting data 
        });
        bulider.addCase(clientOverview.rejected, (state, action) => {
            state.isLoading = false;
        });

        // get client overview chart data for dashboard
        bulider.addCase(clientChartData.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(clientChartData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.clientOverviewChart = action?.payload; // take array list for getting data 
        });
        bulider.addCase(clientChartData.rejected, (state, action) => {
            state.isLoading = false;
        });
    }
})

export default DashOptionsSlice.reducer;